import { Box, SxProps, Theme, useTheme } from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import { FormattedMessage as T } from "react-intl";
import { useParams } from "react-router-dom";
import { CourseDetailsSummary } from "./CourseDetailsSummary";
import EnrollmentUsers from "./EnrollmentUsers";

const useStyles = (theme: Theme): { [key: string]: SxProps } => ({
  title: {
    fontSize: "1.2em",
    color: theme.palette.primary.main,
    fontWeight: "bold",
    my: 2,
  },
});

type CourseDetailsEnrollUsersProps = {
  isSeries?: boolean;
};

export function CourseDetailsEnrollUsers({
  isSeries = false,
}: CourseDetailsEnrollUsersProps) {
  let { id } = useParams();
  const styles = useStyles(useTheme());

  return (
    <>
      <RedirectBackButton labelKey="back" />
      <Box sx={styles.title}>
        <T id="enrollUsers" />
      </Box>
      <CourseDetailsSummary skuId={id!} isSeries={isSeries} />
      <EnrollmentUsers skuId={id!} />
    </>
  );
}
